import { Stack, Tooltip, TooltipProps, Typography } from '@mui/material'
import Button from '@mui/material/Button'
import { FC, PropsWithChildren, useMemo } from 'react'
import { useUserStore } from '../../../../store/storeUser'
import { useWrapperStore } from '../../../../store/storeWrapper'

type Props = PropsWithChildren<{
    title: string
    placement?: TooltipProps['placement']
    decription: string
    element?: React.ReactNode
    open?: boolean
}>

export const OnboardingTooltip: FC<Props> = ({
    children,
    element,
    title,
    decription,
    placement = 'right-start',
    open,
}) => {
    const { stepOnboarding, dialogsOpen, setStepOnboarding, setDialogsOpen } = useWrapperStore(
        (state) => state,
    )
    const { userPersonalData, updateUserPersonalData } = useUserStore()

    const handleClick = async () => {
        if (stepOnboarding === 5) {
            setStepOnboarding(100)
            setDialogsOpen(true)
        } else {
            setStepOnboarding(stepOnboarding + 1)
        }
        await updateUserPersonalData(
            { banners: { [`step_onboarding_${stepOnboarding}`]: true } },
            false,
        )
    }

    const handleClickSkip = () => {
        setStepOnboarding(100)
        const banners = {}

        for (let i = stepOnboarding; i < 6; i++) {
            banners[`step_onboarding_${i}`] = true
        }

        updateUserPersonalData({ banners }, false)
        setDialogsOpen(true)
    }

    const tooltipTitle = useMemo(
        () => (
            <Stack gap="4px">
                <Stack>
                    <Typography variant="h6" color="#181B25">
                        {title}
                    </Typography>
                    <Typography variant="body2" color="#181B25">
                        {decription}
                    </Typography>
                    <Stack
                        direction="row"
                        gap={1}
                        alignItems="center"
                        mt={1}
                        sx={{ justifyContent: 'space-between' }}>
                        <Typography variant="body2" color="#5A5C5E">
                            {stepOnboarding} из 5
                        </Typography>
                        <Stack direction="row" gap={1}>
                            <Button variant="outlined" color="primary" onClick={handleClickSkip}>
                                Пропустить
                            </Button>
                            <Button variant="contained" color="primary" onClick={handleClick}>
                                {stepOnboarding === 5 ? 'Готово' : 'Дальше'}
                            </Button>
                        </Stack>
                    </Stack>
                </Stack>
                {/*{element}*/}
            </Stack>
        ),
        [title, decription, stepOnboarding, handleClick, handleClickSkip],
    )

    const tooltipSlotProps = useMemo(
        () => ({
            tooltip: {
                sx: {
                    width: '376px',
                    maxWidth: '376px',
                    backgroundColor: '#fff',
                    color: '#181B25',
                    padding: '16px',
                    borderRadius: '12px',
                    border: '1px solid #E5E5E7',
                    background: '#FFF',
                    boxShadow: '0 3px 10px 0 rgba(0, 0, 0, 0.04)',
                    marginLeft: '8px !important',
                    marginTop: '8px !important',
                },
            },
        }),
        [],
    )

    return (
        <Tooltip
            placement={placement}
            open={open}
            enterTouchDelay={0}
            title={tooltipTitle}
            slotProps={tooltipSlotProps}>
            {children}
        </Tooltip>
    )
}
